import * as React from "react";
import {cx} from "emotion";

import "./live-chat-button.scss";

export const LiveChatButton = ({
    webchat,
    disabled
}: {
    webchat: any,
    disabled: boolean
}) => (
    <button
        className={cx("live-chat-button live-chat-button-9w2", {"webchat-minimized": webchat.minimized})}
        xd-qa-type="button"
        xd-qa-name={`Live Chat${disabled && " (Offline)"}`}
        onClick={webchat.show}
        disabled={disabled}
    >
        <i className="fa fa-comments"/>{" "}
        Live Chat {disabled && "(Offline)"}

        {webchat.minimized && (
            <span className="plus" xd-qa-type="icon" xd-qa-name="maximize">+</span>
        )}
    </button>
);